module.exports = __webpack_public_path__ + "img/income_active.dea2c67a.svg";